import { render, staticRenderFns } from "./TickBox.vue?vue&type=template&id=dfbfa164&scoped=true&"
import script from "./TickBox.vue?vue&type=script&lang=js&"
export * from "./TickBox.vue?vue&type=script&lang=js&"
import style0 from "./TickBox.vue?vue&type=style&index=0&id=dfbfa164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbfa164",
  null
  
)

export default component.exports